<template>
  <page-article>
    <div class="col-12 page_content_area">
      <campus-recruiting-introduction
        :basic-info="currentRecruitmentGetter"
      />
      <div class="col-12">
        <div
          v-if="!isStudentGetter"
          class="row justify-content-center mb-5"
        >
          <div class="col-md-3 col-sm-6">
            <button-wrapper
              v-if="!isEnterpriseEnrolled && !isExpired && !notTimeYet"
              class="btn--fill"
              color="darken_blue"
              size="lg"
              @click="enrollCampusRecruitment"
            >
              報名活動
            </button-wrapper>

            <button-wrapper
              v-else
              class="btn--fill"
              size="lg"
              disabled
            >
              {{ isEnterpriseEnrolled ? '已報名活動' : notTimeYet ? '尚未開放報名' : '報名已截止' }}
            </button-wrapper>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row justify-content-center">
          <div class="col-12">
            <navigation
              :list="segments"
              :list-status="status"
              :active-value="activeSegment"
              variety="segmented"
              @active:updated="updateActiveSegment"
            />
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12">
            <keep-alive>
              <component
                :is="activeSegmentComponent"
                :item="currentProps"
              />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <redirect-login-page-modal
      v-if="isOpenRedirectModal"
      auth-type="enterprise"
      :is-modal-open="isOpenRedirectModal"
      @modal:close="closeRedirectModal"
    />
    </div>
  </page-article>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Navigation from '~components/common/Navigation'
import pageArticle from '~components/pages/Article'
import ButtonWrapper from '~components/common/buttons'
import CampusRecruitingIntroduction from './common/CampusRecruitingIntroduction'
import RecruitmentOrientation from './nested/RecruitmentOrientation'
import CareerExpo from './nested/CareerExpo'
import RedirectLoginPageModal from '~components/common/modal/RedirectLoginPage'

const ENABLE = true
const DISABLE = false
export default {
  name: 'CampusRecruitingDetailsContent',
  components: {
    Navigation,
    pageArticle,
    ButtonWrapper,
    CampusRecruitingIntroduction,
    RecruitmentOrientation,
    CareerExpo,
    RedirectLoginPageModal
  },
  data () {
    return {
      segments: ['說明會', '博覽會'],
      status: [ENABLE, ENABLE],
      segmentComponents: [RecruitmentOrientation, CareerExpo],
      activeSegment: '',
      isOpenRedirectModal: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isEnterpriseGetter',
      'isStudentGetter'
    ]),
    ...mapGetters('pages/enterprises', [
      'isEnrolledCurrentCampusRecruitmentGetter'
    ]),
    ...mapGetters('pages/campus-recruiting', [
      'currentRecruitmentGetter',
      'currentOrientationInfoGetter',
      'currentExpoInfoGetter'
    ]),
    activeSegmentComponent () {
      if (!this.activeSegment) {
        return ''
      }
      return this.segmentComponents[this.segments.indexOf(this.activeSegment)]
    },
    currentProps () {
      if (this.activeSegmentComponent.name === 'RecruitmentOrientation') {
        return { orientationInfo: this.currentOrientationInfoGetter }
      }
      if (this.activeSegmentComponent.name === 'CareerExpo') {
        return { expoInfo: this.currentExpoInfoGetter }
      }
      return {}
    },
    notTimeYet () {
      if (this.currentRecruitmentGetter.recruitment_enrollment_start_date) {
        return this.$moment().isBefore(this.$moment(this.currentRecruitmentGetter.recruitment_enrollment_start_date))
      }
      return true
    },
    isExpired () {
      if (this.currentRecruitmentGetter.recruitment_enrollment_end_date) {
        return this.$moment(this.currentRecruitmentGetter.recruitment_enrollment_end_date).isBefore(this.$moment())
      }
      return true
    },
    isEnterpriseEnrolled () {
      if (this.isEnterpriseGetter) {
        return this.isEnrolledCurrentCampusRecruitmentGetter(Number(this.$route.params.id))
      }
      return false
    }
  },
  watch: {
    currentRecruitmentGetter (value) {
      this.status[0] = value.recruitment_orientation_enabled
      this.status[1] = value.career_expo_enabled
      if (!value.recruitment_orientation_enabled && !value.career_expo_enabled) {
        this.activeSegment = ''
      } else if (!value.recruitment_orientation_enabled) {
        this.activeSegment = '博覽會'
      } else {
        this.activeSegment = '說明會'
      }
    }
  },
  async created () {
    this.togglePageLoader(true)
	try {
		await this.getRecruitmentDetailsById(this.$route.params.id);
	}
	catch (err) {
		this.$router.push('/campus-recruiting');
	}
    if (this.isEnterpriseGetter) {
      await this.getAllCampusRecruitments()
    }
    this.togglePageLoader(false)
  },
  methods: {
    ...mapActions('pages/campus-recruiting', [
      'getRecruitmentDetailsById'
    ]),
    ...mapActions('layouts', [
      'toggleModal'
    ]),
    ...mapActions('pages/enterprises', [
      'getAllCampusRecruitments'
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    updateActiveSegment (segment) {
      this.activeSegment = segment
    },
    closeRedirectModal () {
      this.isOpenRedirectModal = false
      this.toggleModal(false)
    },
    enrollCampusRecruitment () {
      if (this.isEnterpriseGetter) {
        this.$router.push({
          path: `/campus-recruiting/${this.$route.params.id}/enrollment-process`
        })
      } else {
        this.isOpenRedirectModal = true
      }
      this.toggleModal(true)
    }

  }
}
</script>
